import gql from 'graphql-tag'

export const courseMonitoringListFragment = gql`
  fragment CourseMonitoringListFragment on Course {
    id
    name
    integrationCourseLink
    participantsCount(areaId: $areaId, ransack: $participantsQuery)
    hours
    progress(areaId: $areaId, ransack: $participantsQuery) {
      finish
      inProgress
      pending
    }
    progressEvaluations(areaId: $areaId, ransack: $participantsQuery) {
      reproved
      approved
      total
    }
  }
`

export const courseFragment = gql`
  fragment CourseFragment on Course {
    id
    name
    integrationCourseLink
    participantsCount(
      areaId: $areaId
      ransack: $participantsQuery
      includeInactiveMonitoringStats: true
    )
    hours
    state
    progress(
      areaId: $areaId
      ransack: $participantsQuery
      includeInactiveMonitoringStats: true
    ) {
      finish
      inProgress
      pending
    }
    progressEvaluations(
      areaId: $areaId
      ransack: $participantsQuery
      includeInactiveMonitoringStats: true
    ) {
      reproved
      approved
      total
    }
    synchronousCourse {
      id
      evaluationsCount
    }
    hasLiveSessionBlocks
    normative
  }
`

export const externalCoursesFragment = gql`
  fragment ExternalCoursesFragment on ExternalCourse {
    id
    name
    code
    institution
    hours
    startDate
    endDate
    participantsCount
    progress {
      finish
      inProgress
      pending
    }
    progressEvaluations {
      reproved
      approved
      total
    }
    certificatesCount
  }
`
